import { TextField } from "@/components/kit";
import StepCard from "../components/StepCard";
import TextArea from "@/components/kit/TextArea";
import { useAddRoleStore } from "./useAddRoleStore";

function AddRoleDetailStep() {
  const { name, setName, description, setDescription } = useAddRoleStore();
  return (
    <StepCard
      title="Role details"
      description="Name the role and optionally provide a description to help identify its purpose within your organization."
      className="!h-full"
    >
      <div className="px-6 flex flex-col gap-y-5 mb-4">
        <TextField
          value={name}
          onChange={(e) => setName(e.target.value)}
          label="Name"
        />
        <TextArea
          rows={9}
          autoComplete="off"
          autoCorrect="off"
          name="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder={"Description (optional)"}
        />
      </div>
    </StepCard>
  );
}

export default AddRoleDetailStep;
